import React from "react";

const CenterPiece = () => {
    let headerStyle = {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        minHeight: '100vh'
    };

    const textStyle = {
        paddingBottom: '3rem',
        color: 'white',
        textAlign: 'center',
        fontFamily: 'TheCartel',
        fontStyle: 'italic',
        fontWeight: 100,
        fontSize: 'clamp(1rem, 4vw, 2rem)'
    };

    return (
        <header style={headerStyle}>
            <div style={textStyle}>
                Married the 6th of May 2023
            </div>
        </header>
    );
}

export let SaveTheDate = () => {
    return (
        <CenterPiece />
    )
}